import Accordion from "@/components/Accordion";
import Slider from "@/components/Slider";
import { StyleConfigModel } from "@/pages/Messaging/types";
import React from "react";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

type LauncherPosition = "Left" | "Right";

const positions: LauncherPosition[] = ["Left", "Right"];

export function Layout(props: Props) {
  const workingStyleConfig = props.workingChatWindow.styleConfig || {};

  const updateStyleConfig = (updates: Partial<StyleConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      styleConfig: {
        ...workingStyleConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="layout" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Layout</Accordion.Title>
        <Accordion.SubTitle>
          Customize the overall layout, positioning of elements
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="text-sm font-medium mb-2">Window Position</div>
          <div className="flex gap-4 mb-4">
            {positions.map((position) => {
              const isSelected =
                workingStyleConfig.launcherPosition === position;
              return (
                <div
                  key={position}
                  className={`flex justify-center items-center rounded-lg py-2 px-6 w-32 cursor-pointer border-2 ${
                    isSelected
                      ? "border-cornflower-blue-500 bg-cornflower-blue-50"
                      : "border-slate-300 bg-white"
                  }`}
                  onClick={() =>
                    updateStyleConfig({ launcherPosition: position })
                  }
                >
                  <div className="w-4 h-4 relative bg-slate-500 rounded-sm overflow-hidden">
                    <div
                      className={`w-[4px] h-[6px] top-[6px] absolute bg-white ${
                        position === "Left" ? "left-[2px]" : "right-[2px]"
                      }`}
                    />
                  </div>
                  <div className="text-sm font-medium text-slate-600 ml-2">
                    {position}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex justify-between items-center">
            <div className="text-sm font-medium mb-2">Horizontal Offset</div>
            <input
              type="number"
              className="border border-slate-300 rounded-md p-2 w-16"
              value={workingStyleConfig.sideSpacing}
              onChange={(e) => {
                let value = parseInt(e.target.value);
                if (isNaN(value)) value = 0;
                if (value > 80) value = 80;
                if (value < 0) value = 0;

                updateStyleConfig({ sideSpacing: value });
              }}
              min={0}
              max={80}
            />
          </div>
          <Slider
            max={80}
            min={0}
            onChange={(value) => updateStyleConfig({ sideSpacing: value })}
            value={workingStyleConfig.sideSpacing}
          />
          <div className="flex justify-between items-center">
            <div className="text-sm font-medium mb-2">Vertical Offset</div>
            <input
              type="number"
              className="border border-slate-300 rounded-md p-2 w-16"
              value={workingStyleConfig.bottomSpacing}
              onChange={(e) => {
                let value = parseInt(e.target.value);
                if (isNaN(value)) value = 0;
                if (value > 80) value = 80;
                if (value < 0) value = 0;

                updateStyleConfig({ bottomSpacing: value });
              }}
              min={0}
              max={80}
            />
          </div>
          <Slider
            max={80}
            min={0}
            onChange={(value) => updateStyleConfig({ bottomSpacing: value })}
            value={workingStyleConfig.bottomSpacing}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
